import { Byline } from '#/components/Byline/Byline';
import { BodySmall } from '#/components/Text/BodySmall';
import type { CmsApiAuthor } from '#/modules/cms/api/types/CmsApiAuthor';
import { colors } from '#/theme/theme';
import type { DatetimeNoTzString } from '#/types/TypedDateString';

import {
  CmsAuthorCard_Box_1,
  CmsAuthorCard_Box_2,
} from './CmsAuthorCard.styled';

type Props = {
  fullWidthLayout?: boolean;
  author: CmsApiAuthor;
  homePageUrl: string;
  postedDate: DatetimeNoTzString;
  showDate: boolean;
};

export function CmsAuthorCard({
  fullWidthLayout,
  author,
  homePageUrl,
  postedDate,
  showDate,
}: Props) {
  return (
    <CmsAuthorCard_Box_2
      data-qa-id="author-card"
      data-full-width-layout={fullWidthLayout ? true : undefined}
    >
      <Byline
        slug={author.slug}
        name={author.name}
        image={author.image ?? undefined}
        homePageUrl={homePageUrl}
        postedDate={postedDate}
        showDate={showDate}
      />

      <CmsAuthorCard_Box_1>
        <BodySmall
          dangerouslySetInnerHTML={{
            __html: author.description,
          }}
          qaId="author-card-description"
          style={{ color: colors.lightContentGrey }}
        />
      </CmsAuthorCard_Box_1>
    </CmsAuthorCard_Box_2>
  );
}
